<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="dashboard-container">

    <!-- Header com Filtros -->
    <div class="filter-section">
      <div class="filter-header">
        <mat-icon>dashboard</mat-icon>
        Dashboard
      </div>
      <div class="filter-body">
        <form [formGroup]="filterForm" class="filter-form">
          @if (userAutomaker === null && userDistributor === null) {
            <app-select-form-field
              label="Montadora (OE)"
              [control]="automaker"
              [options]="automakers"
              [display]="companyDisplayName"
              class="filter-field"
            />
          }
          @if (userDistributor === null) {
            <app-select-form-field
              label="Distribuidor (DE)"
              [control]="distributor"
              [options]="distributorOptions"
              [display]="companyDisplayName"
              class="filter-field"
            />
          }
          <mat-form-field subscriptSizing="dynamic" class="filter-field date-filter">
            <mat-label>Intervalo de datas (De / Até)</mat-label>
            <mat-date-range-input [rangePicker]="defaultRangePicker">
              <input matStartDate placeholder="dd/mm/yyyy" formControlName="dateStart" autocomplete="off" />
              <input matEndDate placeholder="dd/mm/yyyy" formControlName="dateEnd" autocomplete="off" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="defaultRangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #defaultRangePicker></mat-date-range-picker>
          </mat-form-field>
        </form>
      </div>
      <div class="filter-footer">
        <div class="filter-footer-left">
          <button mat-flat-button color="accent" class="mic-btn-icon-left" (click)="applyFilters()">
            <mat-icon>search</mat-icon><span>Buscar</span>
          </button>
          <button mat-stroked-button color="primary" class="mic-btn-icon-left" (click)="resetFilters()">
            <mat-icon>refresh</mat-icon><span>Limpar</span>
          </button>
        </div>
      </div>
    </div>

    <!-- KPI Cards -->
    @if (!loading) {
      <div class="kpi-grid" [class.kpi-grid-5]="showCommission">
        <mat-card appearance="outlined" class="kpi-card kpi-success">
          <div class="kpi-icon-wrapper success">
            <mat-icon>attach_money</mat-icon>
          </div>
          <div class="kpi-content">
            <span class="kpi-label">Valor Pneus Atendidos</span>
            <span class="kpi-value success">{{ formatCurrency.format(totalValueServed) }}</span>
          </div>
        </mat-card>

        @if (showCommission) {
          <mat-card appearance="outlined" class="kpi-card kpi-info">
            <div class="kpi-icon-wrapper info">
              <mat-icon>percent</mat-icon>
            </div>
            <div class="kpi-content">
              <span class="kpi-label">Valor Comissão Montadora</span>
              <span class="kpi-value info">{{ formatCurrency.format(commissionValue) }}</span>
            </div>
          </mat-card>
        }

        <mat-card appearance="outlined" class="kpi-card kpi-primary">
          <div class="kpi-icon-wrapper primary">
            <mat-icon>input</mat-icon>
          </div>
          <div class="kpi-content">
            <span class="kpi-label">Total Pneus Ingressados</span>
            <span class="kpi-value primary">{{ totalQuantity }}</span>
          </div>
        </mat-card>

        <mat-card appearance="outlined" class="kpi-card kpi-success">
          <div class="kpi-icon-wrapper success">
            <mat-icon>check_circle</mat-icon>
          </div>
          <div class="kpi-content">
            <span class="kpi-label">Total Pneus Atendidos</span>
            <span class="kpi-value success">{{ totalQuantityServed }}</span>
          </div>
        </mat-card>

        <mat-card appearance="outlined" class="kpi-card kpi-danger">
          <div class="kpi-icon-wrapper danger">
            <mat-icon>cancel</mat-icon>
          </div>
          <div class="kpi-content">
            <span class="kpi-label">Total Pneus Cancelados</span>
            <span class="kpi-value danger">{{ totalQuantityCanceled }}</span>
          </div>
        </mat-card>
      </div>
    }

    <!-- Charts Section -->
    @if (!loading) {
      <div class="charts-grid">
        <mat-card appearance="outlined" class="chart-card">
          <mat-card-header>
            <mat-icon mat-card-avatar class="header-icon chart-icon">bar_chart</mat-icon>
            <mat-card-title>Volume Mensal de Vendas</mat-card-title>
            <mat-card-subtitle>Comparativo de pneus por período</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div class="chart-container">
              @if (hasBarChartData) {
                <mic-bar-chart [datasets]="barChartDatasets" [labels]="barChartLabels" [colors]="barChartColors" legend></mic-bar-chart>
              } @else {
                <div class="chart-empty-state">
                  <mat-icon class="empty-icon">bar_chart</mat-icon>
                  <span class="empty-text">Sem registros no período selecionado</span>
                </div>
              }
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card appearance="outlined" class="chart-card">
          <mat-card-header>
            <mat-icon mat-card-avatar class="header-icon chart-icon">donut_large</mat-icon>
            <mat-card-title>Tempo de Entrega</mat-card-title>
            <mat-card-subtitle>Distribuição por prazo de entrega</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div class="chart-container donut-container">
              @if (hasPieChartData) {
                <mic-donut-chart [datasets]="pieChartDatasets" [labels]="pieChartLabels" legend />
              } @else {
                <div class="chart-empty-state">
                  <mat-icon class="empty-icon">donut_large</mat-icon>
                  <span class="empty-text">Sem registros no período selecionado</span>
                </div>
              }
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    }

    <!-- Table Section -->
    <mat-card appearance="outlined" class="table-card">
      <mat-card-header>
        <mat-icon mat-card-avatar class="header-icon table-icon">list_alt</mat-icon>
        <mat-card-title>Pedidos em andamento/finalizados</mat-card-title>
        <mat-card-subtitle>Lista detalhada de pedidos</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <mic-table #table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
          <ng-container *micCellTemplate="let item; name: 'codeOrderCell'">
            <a class="table-link" (click)="redirectToOrder(item)">{{ item.codeOrder }}</a>
          </ng-container>
          <ng-container *micCellTemplate="let item; name: 'codeOrderClientCell'">
            <a class="table-link" (click)="redirectToOrder(item)">{{ item.codeOrderClient }}</a>
          </ng-container>
          <!-- <ng-container *micTableNoData>
            <mic-empty-state icon="layers_clear" title="Nenhum item para exibir."></mic-empty-state>
          </ng-container> -->
        </mic-table>
      </mat-card-content>
    </mat-card>
  </div>
</mic-spinner-overlay>
